module.exports = __webpack_public_path__ + "img/fire.db0ccc2.svg";